import React, { useEffect } from "react";
import SelectDropdown from "./shared/SelectDropdown";
import { MappingWarningIcon, MappingErrorIcon } from "./shared/MappingIcons";

const ALL_FILES = "__all__";

const SubmissionFileSelector = ({ submissions, selectedFile, setSelectedFile, hideAllFiles }) => {
  useEffect(() => {
    if (hideAllFiles && !selectedFile && submissions.length > 0) {
      setSelectedFile(submissions[0].fileId);
    }
  }, [hideAllFiles, selectedFile, submissions, setSelectedFile]);

  const handleChange = (value) => setSelectedFile(value === ALL_FILES ? null : value);

  const fileOptions = submissions.map((s) => ({
    key: s.fileId,
    value: s.fileId,
    label: s.filename,
    endIcons: (
      <>
        {s.hasErrors && <MappingWarningIcon />}
        {s.hasMappingWarning && <MappingErrorIcon />}
      </>
    ),
  }));

  const options = hideAllFiles
    ? fileOptions
    : [{ value: ALL_FILES, label: "All Files" }, ...fileOptions];

  const value = selectedFile ?? (hideAllFiles ? submissions[0]?.fileId : ALL_FILES);

  return (
    <SelectDropdown options={options} value={value} onChange={handleChange} placeholder="Unknown" />
  );
};

export default SubmissionFileSelector;
